import PropTypes from 'prop-types';
import React, { Component } from 'react';

import { Button, Space, Divider } from 'antd';

import './Toolbar.less';
import { isHistoryStepPossible, doHistoryStep } from '../history';
import getMess from '../../../translations';
import Search from './search';

import icons from '../../../../../../shared/utils/files/antIcons';

const propTypes = {
  items: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      icon: PropTypes.object,
      onClick: PropTypes.func,
    }),
  ),
  newButtonItems: PropTypes.arrayOf(
    PropTypes.shape({
      label: PropTypes.string,
      icon: PropTypes.object,
      onClick: PropTypes.func,
    }),
  ),
  history: PropTypes.shape({
    stack: PropTypes.array,
    currentPointer: PropTypes.number,
  }),
  onMoveBackward: PropTypes.func,
  onMoveForward: PropTypes.func,
  onRefresh: PropTypes.func,
  locale: PropTypes.string,
};
const defaultProps = {
  history: [],
  items: [],
  newButtonItems: [],
  locale: 'en',
};

export default class Toolbar extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showDropdownMenu: false,
    };
  }

  handleShowDropdownMenu = () => {
    this.setState({ showDropdownMenu: true });
  };

  handleHideDropdownMenu = () => {
    this.setState({ showDropdownMenu: false });
  };

  handleMoveBackward = () => {
    const { history } = this.props;
    const newHistory = doHistoryStep(history, -1);
    this.props.onMoveBackward(newHistory);
  };

  handleMoveForward = () => {
    const { history } = this.props;
    const newHistory = doHistoryStep(history, 1);
    this.props.onMoveForward(newHistory);
  };

  handleRefresh = () => {
    this.props.onRefresh();
  };

  handleCopyDefaultFolderStructure = () => {
    this.props.onCopyDefaultFolderStructure();
  };

  checkPermission = (isAccessAllowed, element) => {
    if (isAccessAllowed) {
      return element;
    } else {
      return null;
    }
  };

  render() {
    const { items, newButtonItems, history, search, adminMode } = this.props;

    const itemsElement = items.length
      ? items.map((item, i) => {
          let button = (
            <Button
              type="primary"
              ghost
              key={i}
              disabled={item.disabled}
              title={item.label || ''}
              onClick={(!item.disabled && item.onClick) || (() => {})}
            >
              {item.icon.icon}
            </Button>
          );
          switch (item.id) {
            case 'previewFile':
            case 'download':
              return this.props.permissions ? this.checkPermission(this.props.permissions.filePermissions.canView, button) : null;
            case 'upload':
            case 'uploadFolder':
            case 'createFolder':
            case 'copyTo':
              return this.props.permissions ? this.checkPermission(this.props.permissions.filePermissions.canAdd, button) : null;
            case 'rename':
            case 'descriptionEdit':
            case 'moveTo':
            case 'send':
            case 'markAsInsuredVisible':
            case 'unmarkAsInsuredVisible':
            case 'createNote':
            case 'createTask':
            case 'createServiceRequest':
              return this.props.permissions ? this.checkPermission(this.props.permissions.filePermissions.canEdit, button) : null;
            case 'delete':
              return this.props.permissions ? this.checkPermission(this.props.permissions.filePermissions.canDelete, button) : null;
            default:
              return button;
          }
        })
      : null;

    const newButtonElements = newButtonItems.map((item, i) => {
      const tooltip = item.disabled ? 'Forbidden ' + item.label.toLowerCase() + ' in this place' : item.label;

      let button = (
        <Button type="primary" ghost key={i} disabled={item.disabled} title={tooltip} onClick={(!item.disabled && item.onClick) || (() => {})}>
          {item.icon.icon}
        </Button>
      );

      switch (item.id) {
        case 'previewFile':
        case 'download':
          return this.props.permissions ? this.checkPermission(this.props.permissions.filePermissions.canView, button) : null;
        case 'upload':
        case 'uploadFolder':
        case 'createFolder':
        case 'copyTo':
          return this.props.permissions ? this.checkPermission(this.props.permissions.filePermissions.canAdd, button) : null;
        case 'rename':
        case 'descriptionEdit':
        case 'moveTo':
        case 'send':
        case 'markAsInsuredVisible':
        case 'unmarkAsInsuredVisible':
        case 'createNote':
        case 'createTask':
        case 'createServiceRequest':
          return this.props.permissions ? this.checkPermission(this.props.permissions.filePermissions.canEdit, button) : null;
        case 'delete':
          return this.props.permissions ? this.checkPermission(this.props.permissions.filePermissions.canDelete, button) : null;
        default:
          return button;
      }
    });

    const getMessage = getMess.bind(null, this.props.locale);

    const navButtons = [
      <Button
        type="primary"
        key="nav-1"
        ghost
        disabled={!isHistoryStepPossible(history, -1)}
        title={getMessage('moveBack')}
        onClick={() => this.handleMoveBackward()}
      >
        {icons.moveBackward}
      </Button>,

      <Button
        type="primary"
        key="nav-2"
        ghost
        disabled={!isHistoryStepPossible(history, 1)}
        title={getMessage('moveForward')}
        onClick={() => this.handleMoveForward()}
      >
        {icons.moveForward}
      </Button>,

      <Button type="primary" key="nav-3" ghost title={getMessage('refresh')} onClick={() => this.handleRefresh()}>
        {icons.refresh}
      </Button>,
    ];

    const copyDefaultStructureButton = adminMode
      ? [
          <Button
            type="primary"
            key="copy-def-str"
            ghost
            title={getMessage('copyDefaultFolderStructure')}
            onClick={() => this.handleCopyDefaultFolderStructure()}
          >
            {icons.copy}
          </Button>,

          <Divider key="copy-def-str-div" type="vertical" />,
        ]
      : [];

    return (
      <div className="oc-fm--toolbar">
        <Space>{navButtons}</Space>
        <Divider type="vertical" />
        {copyDefaultStructureButton}
        <Search onSearch={search} />
        <Divider type="vertical" />
        <Space>{newButtonElements}</Space>
        <Divider type="vertical" />
        <Space>{itemsElement}</Space>
      </div>
    );
  }
}

Toolbar.propTypes = propTypes;
Toolbar.defaultProps = defaultProps;
